import { ContentProps } from "components/flexComponents/Content/typings";
import * as React from "react";
import CitiHeaderSection from "./CitiHeaderSection";
import CitiCalculatorContainer from "./CitiCalculatorContainer";

export const CitiCalculatorSectionEditorial = (props: ContentProps) => {
  const { model } = props.flexComponent;

  return (
    <>
      {model.title === "Citi_Calculator_Section_Heading" && (
        <CitiHeaderSection flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
      )}

      {model.title === "Citi_Calculator_Section_Container" && (
        <CitiCalculatorContainer flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
      )}
    </>
  );
};

export default CitiCalculatorSectionEditorial;
